export const stream = `
  query stream($id: ID) {
    stream(id: $id) {
      id
      title
      slug
      info
      startsAt
      cover { name path height width }
      sources { id label slug position assetStatus playbackId playbackToken storyboardToken }

      sections {
        id
        title
        subtitle
        start
        end
        position
        isMain

        speaker {
          id
          name
          organisation
          position
          info
          website

          photo {
            name
            path
            height
            width
          }
        }
      }
    }
  }
`;
